// header
document.querySelectorAll(".c-h-nav-lvl2-details").forEach(summary => {
  summary.addEventListener("mouseover", () => {
    summary.setAttribute("open", "");
    summary.addEventListener("mouseleave", () => {
      summary.removeAttribute("open");
    })
  });
});


// nav pages
document.querySelectorAll(".c-h-button").forEach(button => {
  button.addEventListener("click", () => {
    button.parentElement.parentElement.removeAttribute("open");
  });
});


// Nav drawer open / close
const nd_section = document.getElementById("c-h-drawer-wrapper");

const navDrawerTl = gsap.timeline({ paused: true})
.to("#c-h-drawer", {x: 0, ease: "power1.out", duration: 0.4});

function ndOpen() {
  nd_section.style.display = "grid";
  navDrawerTl.play();
}

function ndClose() {
  navDrawerTl.reverse();
  setTimeout(() => {
    nd_section.style.display = "none";
  }, 400.0);
}

function ndSetOpenEvent() {
  document.querySelectorAll("[data-open-navdrawer]").forEach(function(trigger){
    trigger.addEventListener("click", function(){
      ndOpen();
    });
  });
}
ndSetOpenEvent();

function ndSetCloseEvent() {
  document.querySelectorAll("[data-close-navdrawer]").forEach(function(trigger){
    trigger.addEventListener("click", function(){
      ndClose();
    });
  });

//   document.addEventListener('click', (event) => {
//     if (!event.target.closest('c-h-mobile-nav')) {
//       ndClose();
//     }
//   });
}
ndSetCloseEvent();